import {
    FEEDBACK_GET_MULTIPLE,
    FEEDBACK_GET_ONE,
    FEEDBACK_REGISTER_SUCCESS,
    FEEDBACK_REGISTER_FAIL,
    FEEDBACK_LOADING,
    FEEDBACK_LOADING_ERROR,
    FEEDBACK_ACTIVATE_FAIL,
    FEEDBACK_ACTIVATE_SUCCESS,
    FEEDBACK_UPDATE_SUCCESS,
    FEEDBACK_UPDATE_FAIL,
    FEEDBACK_DELETE_SUCCESS,
    FEEDBACK_DELETE_FAIL,
    FEEDBACK_EDIT
} from "./../types/feedback";

let feedbackStore = JSON.parse(localStorage.getItem('feedback'))

const initialState = {
    isLoading: false,
    feedbacks: feedbackStore ? feedbackStore : [],
    feedback:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newFeedback = [...aluu];
    newFeedback.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newFeedback;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case FEEDBACK_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case FEEDBACK_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case FEEDBACK_GET_MULTIPLE:
            localStorage.setItem('feedback', JSON.stringify(action.payload));
            return {
                ...state,
                feedbacks : action.payload,
                feedback : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case FEEDBACK_GET_ONE:
            let all = [...state.feedbacks];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                feedback : ses,
                MSG:"DONE!!!"
            };
        case FEEDBACK_REGISTER_SUCCESS:
            localStorage.setItem('feedback', JSON.stringify([...state.feedbacks, action.payload]));
            return {
                ...state,
                feedbacks: [...state.feedbacks, action.payload],
                msg:action.msg
            }; 
        case FEEDBACK_ACTIVATE_SUCCESS:
            let ac = changeState(state.feedbacks, action.payload);
            localStorage.setItem('feedback', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                feedbacks: ac
            }
        case FEEDBACK_DELETE_SUCCESS:
            let rem = state.feedbacks.filter(cat => cat.id != action.payload);
            localStorage.setItem('feedback', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                feedbacks: rem
            }
        case FEEDBACK_UPDATE_SUCCESS:
            const findInd = state.feedbacks.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.feedbacks];
            newState[findInd] = action.payload;
            localStorage.setItem('feedback', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                feedbacks : newState,
                feedback:action.payload
            }; 
        case FEEDBACK_LOADING_ERROR:
        case FEEDBACK_ACTIVATE_FAIL:
        case FEEDBACK_REGISTER_FAIL:
        case FEEDBACK_DELETE_FAIL:
        case FEEDBACK_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func